import React from 'react';
import closeIcon from '../images/cross-x-icon.png';
import { QueryItemStyle, ListItem, CloseButton} from '../styles/query_item_styles'


const QueryItem = ({term, ndx, onQuerySelect, updateHoverState, disableHover, props}) => {

  var query_hovered = props.data.query_hovered;

  var style_props
  = (term === query_hovered ) ? true : false;

  var hover_active = true

  return(
      <QueryItemStyle isHovered={style_props} onMouseEnter= {() => updateHoverState(term, hover_active)} onMouseLeave={()=> disableHover()} >
        <ListItem>
          {term}
        </ListItem>
        <CloseButton onClick = {() => onQuerySelect(term, ndx) }>
          <img src= {closeIcon} alt="close" />
        </CloseButton>
      </QueryItemStyle>
  );
};

export default QueryItem;
